import React from 'react'
import GraphWrapper from '@mv-submodules/inplant-plantanalysis-fe-iblu/ui/components/widgets/GraphWrapper/GraphWrapperView'
import { ModelNodeData } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/chronograph'
import NeededChartDataAvailabilityGuard from './NeededChartDataAvailabilityGuard'
import { connect, ConnectedProps } from 'react-redux'
import { Workshift } from '@mv-submodules/inplant-plantanalysis-fe-iblu/types/workshift'

interface ChartProps {
  currentGraph: string[]
  component: ModelNodeData
  toggleCollapse: (id: string) => void
}

interface ChartWrapperOwnProps extends ChartProps {
  children: ({ plant, workShift }: { plant: string; workShift: Workshift }) => JSX.Element
}

interface StateProps {
  plant: string | null
  workShift: Workshift | null
}

const mapStateToProps = (state: any): StateProps => ({
  plant: state.plantSelector.plant,
  workShift: state.plantAnalysis.common.workshift,
})

const connector = connect(mapStateToProps)

type ReduxProps = ConnectedProps<typeof connector>

type Props = ChartWrapperOwnProps & ReduxProps

function ChartWrapper(props: Props) {
  const { currentGraph, component, toggleCollapse, children, plant: nullablePlant, workShift: nullableWorkShift } = props

  return (
    <div className="graph-wrapper" key={component.id}>
      <GraphWrapper active={currentGraph} component={component} toggleCollapse={toggleCollapse}>
        <NeededChartDataAvailabilityGuard plant={nullablePlant} workShift={nullableWorkShift}>
          {({ plant, workShift }) => (
            children({ plant, workShift })
          )}
        </NeededChartDataAvailabilityGuard>
      </GraphWrapper>
    </div>
  )
}

export default connector(ChartWrapper)
export type { ChartProps }